import React from 'react';
import './App.css';
import StaffHeader from './StaffHeader';

function Profile() {
  return (
    <div className="profile-root">
      <StaffHeader />

      <header className="profile-header">
        <div className="profile-main-info">
          <div className="profile-avatar">TK</div>
          <div className="profile-text">
            <h1 className="profile-name">Taylor King</h1>
            <p className="profile-role">Tenant · Elm Court · Room 3B</p>
            <div className="profile-contact">
              <span>taylor.king@example.com</span>
              <span>+1 (555) 123-4567</span>
            </div>
          </div>
        </div>

        <div className="profile-actions">
          <button type="button" className="btn-primary profile-action-btn">
            Edit info
          </button>
          <button
            type="button"
            className="btn-ghost profile-action-btn"
            onClick={() => alert('Open change password flow (wire later).')}
          >
            Change password
          </button>
        </div>
      </header>

      <main className="profile-layout">
        <section className="profile-card">
          <h2 className="profile-card-title">Tenant lease documents</h2>
          <p className="profile-card-sub">
            View and download signed lease agreements and addendums.
          </p>
          <ul className="profile-doc-list">
            <li>
              <div className="profile-doc-main">
                <span className="profile-doc-name">
                  Residential lease · Elm Court · Room 3B
                </span>
                <span className="profile-doc-meta">Signed Jan 1 2025</span>
              </div>
              <button
                type="button"
                className="profile-doc-link"
                onClick={() => alert('Open lease document (wire later).')}
              >
                View
              </button>
            </li>
            <li>
              <div className="profile-doc-main">
                <span className="profile-doc-name">Move-in inspection report</span>
                <span className="profile-doc-meta">Uploaded Jan 3 2025</span>
              </div>
              <button
                type="button"
                className="profile-doc-link"
                onClick={() => alert('Open inspection report (wire later).')}
              >
                View
              </button>
            </li>
          </ul>
        </section>

        <section className="profile-card">
          <h2 className="profile-card-title">Staff task history</h2>
          <p className="profile-card-sub">
            See maintenance tasks previously assigned to this staff member.
          </p>
          <ul className="profile-task-list">
            <li>
              <div className="profile-task-main">
                <span className="profile-task-issue">Leaking kitchen sink</span>
                <span className="profile-task-meta">
                  Elm Court · Room 3B · Completed Mar 11 2026
                </span>
              </div>
              <span className="profile-status profile-status--completed">
                Completed
              </span>
            </li>
            <li>
              <div className="profile-task-main">
                <span className="profile-task-issue">
                  Heating not working in bedroom
                </span>
                <span className="profile-task-meta">
                  Maple Heights · Unit 12A · In progress
                </span>
              </div>
              <span className="profile-status profile-status--in-progress">
                In progress
              </span>
            </li>
            <li>
              <div className="profile-task-main">
                <span className="profile-task-issue">Loose balcony railing</span>
                <span className="profile-task-meta">
                  Harbor View · Suite 7C · Pending
                </span>
              </div>
              <span className="profile-status profile-status--pending">
                Pending
              </span>
            </li>
          </ul>
        </section>
      </main>
    </div>
  );
}

export default Profile;

